// Faithful SVG recreation of the VYFT logo so it adapts to dark/light themes.
export default function Logo({ className = "", showTag = false, markSize = 34 }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <VyftMark size={markSize} />
      <span className="flex flex-col leading-none">
        <span className="font-display font-extrabold tracking-[0.14em] text-[1.35rem]">VYFT</span>
        {showTag && (
          <span className="mt-1 flex items-center gap-1.5 text-[8px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">
            Events <span className="h-1 w-1 rounded-full bg-[#FF1F8E]" /> Media <span className="h-1 w-1 rounded-full bg-[#F97316]" /> Marketing
          </span>
        )}
      </span>
    </span>
  );
}

export function VyftMark({ size = 34 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" aria-label="VYFT" role="img" className="shrink-0">
      <defs>
        <linearGradient id="vyft-pink" x1="20" y1="80" x2="60" y2="20" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF1F8E" />
          <stop offset="1" stopColor="#FF4D7D" />
        </linearGradient>
        <linearGradient id="vyft-orange" x1="45" y1="80" x2="90" y2="10" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF5B57" />
          <stop offset="1" stopColor="#F97316" />
        </linearGradient>
      </defs>
      {/* left magenta blade */}
      <path d="M24 27 L47 71" stroke="url(#vyft-pink)" strokeWidth="13" strokeLinecap="round" strokeLinejoin="round" />
      {/* right orange rising arm */}
      <path d="M43 73 L71 31" stroke="url(#vyft-orange)" strokeWidth="13" strokeLinecap="round" strokeLinejoin="round" />
      {/* rising arrowhead */}
      <path d="M86 11 L61 15 L76 41 Z" fill="url(#vyft-orange)" />
    </svg>
  );
}
